<template>
  <div id="burgerCont" ontouchstart="">
    <div class="tapGlow"></div>
    <div class="burger-piece" :class="{ 'top-active': navIsOpen }"></div>
    <div class="burger-piece" :class="{ 'mid-active': navIsOpen }"></div>
    <div class="burger-piece" :class="{ 'bot-active': navIsOpen }"></div>
  </div>
</template>

<script>
  
export default {
  name: 'HamburgerButton',
  
  computed: {
    navIsOpen() {
      return this.$store.state.nav.isOpen;
    }
  },
  
  methods: {
    toggleNav() {
      this.$store.commit('toggleNav');
    }
  }
}

</script>

<style scoped>
  #burgerCont {
    border: dotted blue 0px;
    width: 40px;
    height: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0px 10px 0px 0px;
    position: relative;
    transition: all 300ms cubic-bezier(.62,-0.54,.16,1.48);
  }
  
  #burgerCont:active {
    transform: scale(1.1);
  }
  
  .burger-piece {
    background-color: var(--hamburger-color);
    height: 2px;
    width: 20px;
    border-radius: 2px;
    margin: 2px;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
    transition: background-color, 1000ms;
    position: relative;
    transition: all 400ms cubic-bezier(.62,-0.54,.16,1.48);
  }
  
  .top-active {
    width: 22px;
    height: 2px;
    transform: translateY(6px);
    background-color: var(--hamburger-active);
  }
  
  .mid-active {
    width: 25px;
    height: 4px;
    background-color: var(--hamburger-active);
    
  }
  
  .bot-active {
    width: 22px;
    height: 2px;
    transform: translateY(-6px);
    background-color: var(--hamburger-active);
  }
</style>
